<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card styleClass="very-compact-card p-3">
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Период</label>
            <crm-daterangepicker
              [value]="[distribution.from, distribution.to]"
              (changeValue)="setDistributionPeriod($event)"
              appendTo="body"></crm-daterangepicker>
            <small
              *ngIf="errors?.from"
              class="p-error">
              {{ errors?.from | join }}
            </small>
            <small
              *ngIf="errors?.to"
              class="p-error">
              {{ errors?.to | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Компания</label>
            <crm-single-select
              [options]="companies"
              [(selectedItem)]="distribution.company"
              [virtualScroll]="true"
              [virtualScrollItemSize]="33"
              [class]="errors?.company ? 'ng-invalid ng-dirty' : ''"
              [styleClass]="errors?.company ? 'ng-invalid ng-dirty' : ''"
              (selectedItemChange)="changeCompany()"
              appendTo="body"></crm-single-select>
            <small
              *ngIf="errors?.company"
              class="p-error">
              {{ errors.company | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Аналитические признаки</label>
            <p-table [value]="[{}]">
              <ng-template pTemplate="header">
                <tr>
                  <th colSpan="2">Конкретное значение</th>
                  <th>Распределить</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body">
                <tr>
                  <td
                    class="font-medium"
                    [ngStyle]="{ 'width.px': 80 }">
                    <label [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.unitsRequired"
                      >Бизнес единица</label
                    >
                  </td>
                  <td>
                    <crm-unit-single-select
                      [(selectedUnit)]="distribution.settings.unit.target"
                      [isError]="$any(errors?.settings?.unit)"
                      [disabled]="distribution.settings.unit.distribute"
                      [showClear]="true"
                      appendTo="body"></crm-unit-single-select>
                  </td>
                  <td>
                    <p-checkbox
                      [(ngModel)]="distribution.settings.unit.distribute"
                      [disabled]="!!distribution.settings.unit.target"
                      [binary]="true"></p-checkbox>
                  </td>
                </tr>

                <tr>
                  <td
                    class="font-medium"
                    [ngStyle]="{ 'width.px': 80 }">
                    <label
                      [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.directionsRequired"
                      >БС</label
                    >
                  </td>
                  <td>
                    <crm-direction-single-select
                      [directions]="directions"
                      [(selectedDirection)]="distribution.settings.direction.target"
                      [styleClass]="errors?.settings?.direction ? 'ng-invalid ng-dirty' : ''"
                      [class]="errors?.settings?.direction ? 'ng-invalid ng-dirty' : ''"
                      [disabled]="distribution.settings.direction.distribute"
                      [showClear]="true"
                      appendTo="body"></crm-direction-single-select>
                  </td>
                  <td>
                    <p-checkbox
                      [(ngModel)]="distribution.settings.direction.distribute"
                      [disabled]="!!distribution.settings.direction.target"
                      [binary]="true"></p-checkbox>
                  </td>
                </tr>

                <tr>
                  <td
                    class="font-medium"
                    [ngStyle]="{ 'width.px': 80 }">
                    <label
                      [class.required-field]="globalService.globalInfo?.requiredAnalyticalFeatures?.filialsRequired"
                      >Филиал</label
                    >
                  </td>
                  <td>
                    <crm-filial-single-select
                      [(selectedFilial)]="distribution.settings.filial.target"
                      [isError]="$any(errors?.settings?.filial)"
                      [disabled]="distribution.settings.filial.distribute"
                      [showClear]="true"
                      appendTo="body"></crm-filial-single-select>
                  </td>
                  <td>
                    <p-checkbox
                      [(ngModel)]="distribution.settings.filial.distribute"
                      [disabled]="!!distribution.settings.filial.target"
                      [binary]="true"></p-checkbox>
                  </td>
                </tr>
              </ng-template>
            </p-table>

            <div *ngIf="errors?.settings">
              <small class="p-error">
                {{ $any(errors.settings) | joinWithChild }}
              </small>
            </div>
          </div>

          <div class="field">
            <label class="font-medium">Валюта</label>
            <crm-currency-single-select
              [currencies]="currencies"
              [(selectedCurrency)]="distribution.currency"
              [customSearch]="true"
              [disabled]="!distribution.company"
              [isError]="$any(errors?.currency)"
              appendTo="body"></crm-currency-single-select>
            <small
              *ngIf="errors?.currency"
              class="p-error">
              {{ errors.currency | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Тип документа</label>
            <crm-document-type-single-select
              [(selectedDocumentType)]="distribution.documentType"
              [isError]="$any(errors?.documentType)"
              appendTo="body"></crm-document-type-single-select>
            <small
              *ngIf="errors?.documentType"
              class="p-error">
              {{ errors.documentType | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Вид операции</label>
            <crm-operation-type-single-select
              [(selectedOperationType)]="distribution.operationType"
              [isError]="$any(errors?.operationType)"
              appendTo="body"></crm-operation-type-single-select>
            <small
              *ngIf="errors?.operationType"
              class="p-error">
              {{ errors.operationType | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Дата документа</label>
            <crm-datepicker
              [(value)]="distribution.date"
              [inputStyleClass]="errors?.date ? 'ng-invalid ng-dirty' : ''"
              appendTo="body"></crm-datepicker>
            <small
              *ngIf="errors?.date"
              class="p-error block">
              {{ errors.date | join }}
            </small>
          </div>
        </div>
      </p-card>

      <p-card styleClass="very-compact-card mt-3 p-3">
        <h3 class="required-field">Сотрудники</h3>

        <div *ngIf="errors?.salaryDistributionUsers">
          <small class="p-error block">
            {{ errors.salaryDistributionUsers | join }}
          </small>
        </div>

        <div class="max-h-29rem overflow-y-auto overflow-x-hidden">
          <crm-table
            *ngIf="distribution?.salaryDistributionUsers?.length"
            styleClass="mb-3 p-datatable-sm"
            [values]="distribution.salaryDistributionUsers"
            (sortChange)="sortChange($event)"
            [columns]="userColumns">
            <ng-template
              #rowTemplate
              let-item="item"
              let-index="rowIndex">
              <tr *ngIf="toItem(item) as item">
                <td>
                  {{ item.user?.name }}
                  <small
                    *ngIf="errors?.salaryDistributionUsers?.[index]?.['user']"
                    class="p-error">
                    {{ errors.salaryDistributionUsers[index]['user'] }}
                  </small>
                </td>
                <td>
                  <p-inputNumber
                    [(ngModel)]="item.amount"
                    (ngModelChange)="changeAmount(item, $event)"
                    class="w-full {{ errors?.salaryDistributionUsers?.[index]?.['amount'] ? 'ng-invalid ng-dirty' : '' }}"
                    styleClass="w-full {{ errors?.salaryDistributionUsers?.[index]?.['amount'] ? 'ng-invalid ng-dirty' : '' }}"></p-inputNumber>
                  <small
                    *ngIf="errors?.salaryDistributionUsers?.[index]?.['amount']"
                    class="p-error">
                    {{ errors.salaryDistributionUsers[index]['amount'] }}
                  </small>
                </td>
                <td>
                  <i
                    class="pi pi-times text-red-500 hover:text-red-300 cursor-pointer"
                    style="font-size: 1.3rem"
                    (click)="deleteUser(item)"></i>
                </td>
              </tr>
            </ng-template>
          </crm-table>
        </div>

        <button
          *ngIf="!isShowUserSelect"
          pButton
          label="Добавить сотрудника"
          icon="pi pi-plus"
          class="p-button-text p-button-success -ml-3"
          (click)="toggleAddUser()"></button>

        <div
          *ngIf="isShowUserSelect"
          class="flex align-items-center gap-3 w-full mt-2">
          <crm-single-select
            optionLabel="profile.name"
            filterBy="profile.name"
            [options]="userOptions"
            (selectedItemChange)="addUser($event)"
            class="flex-grow-1"
            appendTo="body"></crm-single-select>

          <i
            class="pi pi-times text-red-500 hover:text-red-300 cursor-pointer"
            style="font-size: 1.3rem"
            (click)="isShowUserSelect = false"></i>
        </div>
      </p-card>
    </div>
  </div>

  <div class="grid mt-3">
    <div class="col-12 flex flex-wrap justify-content-between">
      <div>
        <button
          pButton
          [label]="saveButtonLabel"
          class="p-button-success mr-2"
          (click)="saveDistribution()"></button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>

<p-dialog
  header="Предупреждение"
  [(visible)]="isShowWarningDialog"
  styleClass="xl:w-4 md:w-7 w-11"
  [draggable]="false"
  [resizable]="false"
  [modal]="true"
  [closable]="false">
  <p class="text-lg">По выбранным аналитическим признакам есть нераспределенные:</p>
  <p
    *ngIf="stat?.projects?.total"
    class="text-lg">
    - Задачи: {{ stat.projects.total | number }} шт.
  </p>
  <p
    *ngIf="stat?.helpdeskTasks?.total"
    class="text-lg">
    - Заявки HD: {{ stat.helpdeskTasks.total | number }} шт.
  </p>
  <p
    *ngIf="stat?.deals?.total"
    class="text-lg">
    - Сделки: {{ stat.deals.total | number }} шт.
  </p>

  <p class="mt-3 text-lg">
    Вы можете их проигнорировать, то тогда документы распределяются по долям без учета времени.
  </p>
  <p class="text-lg">
    Или можете их распределить, то тогда система вас перенаправит на отчет трудозатрат для распределения.
  </p>
  <ng-template pTemplate="footer">
    <button
      pButton
      class="p-button-text p-button-secondary"
      (click)="createDistribution()">
      Игнорировать
    </button>
    <button
      pButton
      class="p-button-text p-button-success"
      (click)="redirectToTimeReport()">
      Распределить
    </button>
  </ng-template>
</p-dialog>

<p-dialog
  header="Предупреждение"
  [(visible)]="isShowUserWarning"
  styleClass="xl:w-4 md:w-7 w-11"
  [draggable]="false"
  [resizable]="false"
  [modal]="true"
  [closable]="false">
  <p class="text-lg">Отсутствует привязка контрагента к сотрудникам:</p>

  <ng-container *ngFor="let user of usersWithoutCounterparty; last as isLast">
    <span class="text-lg">{{ user.profile?.name }}</span>
    {{ isLast ? '' : ', ' }}
  </ng-container>

  <p class="mt-3 text-lg">
    Вы можете проигнорировать предупреждение, тогда по сотруднику/(-ам) документы не будут созданы.
  </p>
  <p class="text-lg">
    Или можете добавить привязку, тогда документы по сотруднику/(-ам) будут созданы с выбранным контрагентом.
  </p>
  <ng-template pTemplate="footer">
    <button
      pButton
      class="p-button-text p-button-secondary"
      (click)="closeDialog()">
      Игнорировать
    </button>
    <button
      pButton
      class="p-button-text p-button-success"
      (click)="redirectToUserList()">
      Привязать
    </button>
  </ng-template>
</p-dialog>
